import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChanges, Optional, SkipSelf, HostListener } from '@angular/core';
import { CustomsnapshotService } from '../../snapshot/Services/customsnapshot.service';
import { SnapshotService } from '../../snapshot/Services/snapshot.service';
import * as _ from 'lodash';
import { checkboxSelectionWithParentSnapshot } from 'src/app/common/models/crosstab.model';
import { InsightsModel } from 'src/app/common/models/common.model';
import { ChatbotService } from 'src/app/common/services/chatbot.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { Subscription } from 'rxjs';
import { ChatbotexpandComponent } from '../chatbotexpand.component';

@Component({
    selector: 'app-output-popup-askme',
    templateUrl: './askme_output-popup.component.html',
    styleUrls: ['./askme_output-popup.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [SnapshotService]
})
export class OutputPopupAskMeComponent implements OnDestroy {
    @Output() dataEvent = new EventEmitter<boolean>();
    @Output() dataEventTrend = new EventEmitter<boolean>();
    @Output() dataEventCustom = new EventEmitter<boolean>();
    @Output() isTrendAvailableChange = new EventEmitter<boolean>();
    @Output() isSampleSizeChange = new EventEmitter<boolean>();
    @Input() popUpParameter = '';
    @Input() visualization = '';
    @Input() id: any;
    @Input() item: any;
    @Input() data: any;
    @Input() customData: any;
    @Input() snapProduct: string = '';
    @Input() multiFunnelPopup: boolean = false;
    @Input() brandList: any = []
    @Input() metricList: any = [];
    @Input() trendLineView: any;
    @Input() showSnapshotARK: any;
    @Input() snapshotConfig: any = null;
    @Input() masterStudyConfig: any = null;
    @Input() block: any;
    indexVsBrandReference: checkboxSelectionWithParentSnapshot[] = [];
    isviewDropdownOpen: any = false;
    clickedResult = '';
    Top10Container: boolean = false;
    Top10Toggle: boolean = true;
    DataLabelOn: boolean = true;
    BMList: any = [];
    viewList: any = [];
    charttype: string = "";
    zAxisMetric: string = "";
    viewListBrands: any[] = [
        {
            option: "All Brands for Selected Metric",
            selected: true,
        }, {
            option: "All Metrics for Selected Brand",
            selected: false,
        },
    ]
    viewListMarkets: any = [
        {
            option: "All Markets for Selected Metric",
            selected: true,
        }, {
            option: "All Metrics for Selected Market",
            selected: false,
        },
    ]

    // Significance API state
    isSignificanceLoading: boolean = false;
    private _sigSub: Subscription | null = null;

    constructor(
        public _cdref: ChangeDetectorRef,
        private _configCustomService: CustomsnapshotService,
        public _configService: SnapshotService,
        @Optional() @SkipSelf() private _globalConfigService: SnapshotService,
        private _chatbotService: ChatbotService,
        private _loaderService: LoaderService,
        public _chatbotexpandComponent: ChatbotexpandComponent
    ) {
        this.viewList = this.viewListBrands;
    }

    ngOnDestroy() {
        this._sigSub?.unsubscribe();
    }

    @HostListener('document:click', ['$event'])
    onDocumentClick(event: Event) {
        const targetEl = event.target as HTMLElement;

        if (!targetEl.closest('.significance-dropdown-outer-body')) {
            this.significanceDropdownToggle = false;
        }
        if (!targetEl.closest('.confidence-level-outer-body')) {
            this.ConfidenceLevelDropDownToggle = false;
        }
        if (!targetEl.closest('.reference-dropdown-outer-body')) {
            this.referenceDropdownToggle = false;
        }
        if (!targetEl.closest('.base-dropdown-outer-body:not(.branddropdown)')) {
            this.BaseDropDownToggle = false;
        }
        if (!targetEl.closest('.weighted-dropdown-outer-body')) {
            this.weightDropDownToggle = false;
        }
        if (!targetEl.closest('.viewdropdown')) {
            this.isviewDropdownOpen = false;
            this.toogleBrandMetricDropdownOpen = false;
        }
        if (!targetEl.closest('.branddropdown')) {
            this.isFunnelBrandDropdownOpen = false;
        }
        if (!targetEl.closest('.exports-popup-container')) {
            if (this.block) {
                this.block.isExportspopup = false;
            }
        }
        this._cdref.detectChanges();
    }

    gridData: any = [];
    toogleBrandMetricDropdownOpen: any = false;

    // Extra Selections State
    isSigSelected: boolean = true;
    isIndexSelected: boolean = false;
    sigConBaseToggle: boolean = true;
    sigTypeDropdown: boolean = false;
    significanceDropdownToggle: boolean = false;
    ConfidenceLevelDropDownToggle: boolean = false;
    BaseDropDownToggle: boolean = false;
    weightDropDownToggle: boolean = false;
    referenceDropdownToggle: boolean = false;
    displayBrand: boolean = false;
    displayCustomBaseBrand: boolean = false;

    displaySignificance: string = 'None';
    displayConfidenceLevel: string = '90%';
    baseselected: string = 'Answer Base';
    weightSelectedValue: string = 'Primary Weight';
    displayReference: string = 'None';

    brandSearchQuery: string = '';
    brandSelectedValue: any = "";
    brandDropDownToggle: boolean = false;

    significanceTypes: any[] = [];
    significanceVal: any[] = [];
    confidenceLevel: any[] = [];
    base: any[] = [];
    base2: any[] = [];
    weight: any[] = [];
    allbrands: any[] = [];
    allSigBrands: any[] = [];
    index: any[] = [];

    searchQuery: string = '';
    customBaseSearchQuery: string = '';
    selectedReference: any = 'None';
    selectedSigAudienceLevel1: any = null;
    selectedAudienceLevel1: any = null;
    selectedSigBrand: any = null;
    selectedCustomBaseReference: any[] = [];
    tempRemovedCustomBase: any[] = [];
    tempSelectedCustomBase: any[] = [];
    isApplyBase: boolean = true;
    isAnswerBase: boolean = true;
    isCustomBaseSelected: boolean = false;

    y1: any = {};

    // [PARENT SYNC] View Toggle state driven by ChatbotexpandComponent
    @Input() isTrendActive: boolean = false;
    originalSnapshotData: any = null;
    trendlineSnapshotData: any = null;
    isTrendAvailable: boolean = false;
    filteredFunnelData: any = null;
    isChartVisible: boolean = true;

    // Brand Funnel states (Restored)
    isBrandFunnelDropdown: boolean = false;
    funnelBrands: any[] = [];
    selectedFunnelBrand: string = '';
    isFunnelBrandDropdownOpen: boolean = false;

    opobject: any = {
        Column: [], Row: []
    }
    TrendToggleContainer: boolean = false;
    TrendToggleOn: boolean = false;

    sampleSizeOutputData: any = [];
    SingleBrandData: any = [];
    BIPSelected: boolean = false;
    widgetString: string = '';
    OutputdataObject: any = {
        Column: [], Row: []
    }

    toogleViewDropdown() {
        this.isviewDropdownOpen = !this.isviewDropdownOpen;
        event?.stopPropagation();
    }
    closeViewDropdown() {
        this.isviewDropdownOpen = false;
    }
    toogleBrandMetricDropdown() {
        this.toogleBrandMetricDropdownOpen = !this.toogleBrandMetricDropdownOpen
        event?.stopPropagation();
    }


    isTrendView: boolean = true;
    isSampleSize: boolean = false;
    toggleTrendSample(view: any) {
        if (view == 'trendview') {
            this.isTrendView = true;
            this.isSampleSize = false;
        }
        else {
            this.prepareSampleSize();
        }
        this.isSampleSizeChange.emit(this.isSampleSize);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['isTrendActive'] && !changes['isTrendActive'].isFirstChange()) {
            this.handleParentTrendToggle();
        }
        if (changes['snapshotConfig'] || changes['masterStudyConfig']) {
            this.initializeExtraSelections();
        }
        if (this.visualization == 'Funnel Chart' && this.data?.[0]?.metricSelected?.metrics) {
            this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
        }
    }

    private originalMetricSelected: any = '';
    handleParentTrendToggle() {
        if (!this.trendlineSnapshotData) return;

        if (this.isTrendActive) {

            // Backup current selection before clearing for trend view
            if (!this.originalMetricSelected && this.metricSelected) {
                this.originalMetricSelected = this.metricSelected;
            }

            this.customData = JSON.parse(JSON.stringify(this.trendlineSnapshotData));
            this.filteredFunnelData = JSON.parse(JSON.stringify(this.trendlineSnapshotData));
            this.visualization = 'Line Chart';
            this.charttype = 'Line Chart';
            this.initializeTrendDropdownState(true);
        } else {

            // Restore selection
            if (this.originalMetricSelected) {
                this.metricSelected = this.originalMetricSelected;
            }

            this.customData = this.fixPieChartData(JSON.parse(JSON.stringify(this.originalSnapshotData)));
            this.filteredFunnelData = JSON.parse(JSON.stringify(this.originalSnapshotData));
            this.visualization = this.originalSnapshotData.widgetchart_name;
            this.charttype = this.originalSnapshotData.widgetchart_name;

            if (this.isBrandFunnelDropdown) {
                this.filterFunnelData();
            }
        }
        this._cdref.detectChanges();
        this._cdref.markForCheck();
    }

    private getCompareAcrossKey(): string {
        return (this._configService.selectedcompareacrossOption || this.customData?.selectedcompareacrossOption || this.customData?.snapshot_type || '')
            .replace(/\s+/g, '')
            .toLowerCase();
    }

    private getMetricDisplayName(metric: any): string {
        return metric?.option ?? metric?.metricName ?? metric?.rowChild ?? '';
    }

    private parseMaybeJson(value: any): any {
        if (typeof value !== 'string') return value;
        try {
            return JSON.parse(value);
        } catch {
            return value;
        }
    }

    private normalizeTrendRows(rawData: any[]): any[] {
        const baseType = this._configService.getDropdownValues()?.baseType || this.baseselected || 'Answer Base';
        return _.cloneDeep(rawData || []).map((d: any) => {
            const rawLvl1 = d.Level1ColChild || d.lvl1Child || d.colChild;
            return {
                ...d,
                data: this._configService.weightToggle(baseType, this._configService.weightSelected, d),
                data2: this._configService.weightToggleIndex(baseType, this._configService.weightSelected, d),
                lvl1Child: rawLvl1,
                colChild: d.colChild || d.colVariableCode || '',
                rowChild: d.rowChild || d.WidgetMetrics || d.metricName || d.option || 'Metric',
                baseValueforLSorIs: this._configService.finalLeftPanelSubmitObject?.isTotalBase
                    ? d.totalUnweightedBase
                    : d.answerUnweightedBase,
                changeVsPY: this._configService.finalLeftPanelSubmitObject?.isTotalBase
                    ? d.changeVsPY_Total
                    : d.changeVsPY_Answer,
                Significance_Value: this._configService.finalLeftPanelSubmitObject?.isTotalBase
                    ? d.Significance_Total
                    : d.Significance_Answer
            };
        });
    }

    private createMetricValuesFromSnapshotContract(sourceData: any, trendRows: any[]): any[] {
        const rawSourceMetricValues = sourceData?.metric?.[0]?.metric_value || [];
        const sourceMetricValues = Array.isArray(rawSourceMetricValues) ? rawSourceMetricValues : [rawSourceMetricValues];
        const parsedMetricValues = sourceMetricValues.flatMap((mv: any) => {
            const parsed = this.parseMaybeJson(mv);
            return Array.isArray(parsed) ? parsed : [parsed];
        }).filter(Boolean);

        const metricsAvailable = parsedMetricValues.length > 0
            ? parsedMetricValues
            : Object.keys(_.groupBy(trendRows, (d: any) => d.rowChild)).map((name, index) => ({
                option: name,
                metricName: name,
                selectorder: index + 1
            }));

        return metricsAvailable.map((metric: any, index: number) => {
            const metricName = this.getMetricDisplayName(metric);
            let rows = trendRows.filter((row: any) => {
                const rowName = (row.rowChild || '').toString();
                const metricText = (metricName || '').toString();
                return rowName === metricText || rowName.replace(/\s+/g, '').toLowerCase().includes(metricText.replace(/\s+/g, '').toLowerCase());
            });

            if (rows.length === 0 && metricsAvailable.length === 1) {
                rows = trendRows;
            }

            rows = this.sortTrendRowsSafely(rows);
            return {
                ...metric,
                option: metric.option ?? metric.metricName ?? metricName,
                metricName: metric.metricName ?? metric.option ?? metricName,
                selectorder: metric.selectorder ?? metric.selectOrder ?? index + 1,
                data: rows
            };
        }).filter((metric: any) => metric.data?.length > 0);
    }

    private sortTrendRowsSafely(rows: any[]): any[] {
        const clonedRows = _.cloneDeep(rows || []);
        try {
            if (clonedRows.every((row: any) => (row?.lvl1Child || '').includes('|'))) {
                return this._configService.sortTrendTimeporiodData(clonedRows);
            }
        } catch {
            return clonedRows;
        }
        return clonedRows;
    }

    private buildAskMeTrendlineData(rawTrendData: any[]): any {
        const normalizedTrendRows = this.normalizeTrendRows(Array.isArray(rawTrendData) ? rawTrendData : []);
        this._configService.trendOutputDbCallData = JSON.parse(JSON.stringify(normalizedTrendRows));
        const metricValues = this.createMetricValuesFromSnapshotContract(this.originalSnapshotData, normalizedTrendRows);

        // Mutate metricValues to ensure lineortrendchart1 renders legend names correctly without modifying the shared chart component
        metricValues.forEach((mv: any) => {
            if (mv.data) {
                mv.data.forEach((d: any) => {
                    // lineortrendchart1 hardcodes `dataArr.colChild.split("|")[1]` for legend names.
                    // We pad it with 'dummy|' so that `[1]` safely evaluates to our intended last-level string.
                    if (d.colChild) {
                        const lastLevel = d.colChild.includes('|') ? d.colChild.split('|').pop() : d.colChild;
                        d.colChild = 'dummy|' + lastLevel;
                    }
                    if (d.rowChild && d.rowChild.includes('|')) {
                        d.rowChild = d.rowChild.split('|').pop();
                    }
                });
            }
            if (mv.option && mv.option.includes('|')) {
                mv.option = mv.option.split('|').pop();
            }
            if (mv.metricName && mv.metricName.includes('|')) {
                mv.metricName = mv.metricName.split('|').pop();
            }
        });

        return {
            ...this.originalSnapshotData,
            widgetchart_name: 'Line Chart',
            metric: [{
                ...(this.originalSnapshotData?.metric?.[0] || {}),
                metric_group: this.originalSnapshotData?.metric?.[0]?.metric_group || '',
                metric_option: this.originalSnapshotData?.metric?.[0]?.metric_option || 'Metric : ',
                metric_value: metricValues
            }],
            noData: metricValues.length === 0,
            noDataAvailble: metricValues.length === 0
        };
    }

    private initializeTrendDropdownState(forceDefault = false) {
        if (!this.trendlineSnapshotData) return;

        const compareAcross = this.getCompareAcrossKey();
        if (compareAcross === 'multiplebrands') {
            this.viewList = this.viewListBrands;
            this.viewselected = this.viewList[0].option;
        } else if (compareAcross === 'multiplemarkets') {
            this.viewList = this.viewListMarkets;
            this.viewselected = this.viewList[0].option;
        }

        const metricValues = this.trendlineSnapshotData?.metric?.[0]?.metric_value || [];
        const metrics = metricValues.map((m: any) => this.getMetricDisplayName(m)).filter(Boolean);
        const brands = Array.from(new Set(metricValues.flatMap((m: any) =>
            (m.data || []).map((d: any) => d.colChild).filter(Boolean)
        )));

        this.metricList = metrics.map((option: any, index: number) => ({
            option,
            selected: index === 0
        }));
        this.brandList = brands.map((option: any, index: number) => ({
            option,
            selected: index === 0
        }));

        const supportsSnapshotTrendSwitcher = compareAcross === 'multiplebrands' || compareAcross === 'multiplemarkets';
        if (supportsSnapshotTrendSwitcher) {
            const metricStillValid = this.metricList.some((m: any) => m.option === this.metricSelected);
            if (forceDefault || !metricStillValid) {
                this.metricSelected = this.metricList[0]?.option || '';
            }
            this.brandSelected = '';
            this.BMList = this.metricList;
        } else {
            this.metricSelected = '';
            this.brandSelected = '';
            this.BMList = this.metricList;
        }
    }

    closeBrandMetricDropdown() {
        this.toogleBrandMetricDropdownOpen = false;
    }

    private fixPieChartData(data: any) {
        if (!data) return data;
        const chartName = data.widgetchart_name;

        // Piechart23Component and potentially others exhibit a double metric[0] indexing bug in their ngOnInit
        // We satisfy this by nesting the metric array one level deeper if it's missing.
        if (chartName === '05/PIE CHART' || chartName === '01/PIE CHART' || chartName === '09/PIE CHART') {
            if (data.metric && data.metric[0] && !data.metric[0].metric) {
                const fixed = JSON.parse(JSON.stringify(data));
                // Add a redundant 'metric' layer inside the first metric element to satisfy line 91 of the broken component
                fixed.metric[0].metric = JSON.parse(JSON.stringify(data.metric));
                return fixed;
            }
        }
        return data;
    }

    ngOnInit() {
        // Sync local SnapshotService with global session state before initialization
        if (this._globalConfigService && this._configService) {
            // [SYNC] Inherit critical snapshot context from global service to ensure local isolated service 
            // evaluates multi-brand/multi-market visibility correctly.
            this._configService.selectedcompareacrossOption = this._globalConfigService.selectedcompareacrossOption;
            this._configService.selectedSnapshotType = this._globalConfigService.selectedSnapshotType || this._configService.selectedSnapshotType;

            this._configService.ISthreshold = this._globalConfigService.ISthreshold;
            this._configService.LBthreshold = this._globalConfigService.LBthreshold;
            this._configService.userRole = this._globalConfigService.userRole;
            this._configService.clientName = this._globalConfigService.clientName || this._configService.clientName;
            (this._configService as any).isAskme = true;

            // Sync global color maps to ensure consistent visualization across isolated blocks
            this._configService.setGlobalColorMap(this._globalConfigService.getGlobalColorMap());
            this._configService.setGlobalColorMapLinearGradient(this._globalConfigService.getGlobalColorMapLinearGradient());
            this._configService.setGlobalMetricColorMap(this._globalConfigService.getGlobalMetricColorMap());
            this._configService.setGlobalMetricColorMapLinearGradient(this._globalConfigService.getGlobalMetricColorMapLinearGradient());

        }

        // Defensive initialization for shared Table1Component crash prevention
        if (!this._configService.allPageOutputDataWithoutTrend) {
            this._configService.allPageOutputDataWithoutTrend = [[]];
        } else if (!this._configService.allPageOutputDataWithoutTrend[0]) {
            this._configService.allPageOutputDataWithoutTrend[0] = [];
        }

        // Apply bug-fix for broken Pie components before any rendering happens
        this.customData = this.fixPieChartData(this.customData);

        // Ensure item and customData have valid customizationProperties to prevent JSON.parse in Table1 OnInit
        const standardDefaults = JSON.stringify({
            CalculationLogic: 'None',
            enableDataBars: true,
            decimalRoundOff: 0,
            datalabelFormat: 'percentage'
        });

        if (this.item && !this.item.customizationProperties) {
            this.item.customizationProperties = standardDefaults;
        }
        if (this.customData && !this.customData.customizationProperties) {
            this.customData.customizationProperties = standardDefaults;
        }

        // Ensure current widget is present in tracking array so table1's OnInit iteration succeeds
        if (this.item && this.item.widget_name) {
            const exists = this._configService.allPageOutputDataWithoutTrend[0].some(
                (w: any) => w.widget_name === this.item.widget_name
            );
            if (!exists) {
                this._configService.allPageOutputDataWithoutTrend[0].push(this.item);
            }
        }

        if (this.snapProduct == "custom") {
            this.charttype = this.customData?.widgetchart_name;
            const originalVisualization = this.visualization;

            if (this.customData?.metric && Array.isArray(this.customData.metric)) {
                const FoundItem = this.customData.metric.find((item: any) => item.metric_option === "ZAxis Metric : ");
                if (FoundItem)
                    this.zAxisMetric = FoundItem.metric_value?.[0]?.option;
            }

            //  this.zAxisMetric = this.customData.metric.find((item:any) => item.metric_option === "ZAxis Metric : "
            //                                                           ).metric_value[0].option;
            this.charttype = this.customData?.widgetchart_name;

            // [FIX] Proactively initialize SnapshotService metadata for chatbot environment
            // This prevents the shared trend chart from crashing on undefined properties
            if (this._configService) {
                if (!this._configService.finalLeftPanelSubmitObject) {
                    this._configService.finalLeftPanelSubmitObject = { isTotalBase: false };
                }
                if (!this._configService.selectedSnapshotType) {
                    this._configService.selectedSnapshotType = this.customData.snapshot_type || "Single Brand";
                }
                if (!this._configService.selectedcompareacrossOption) {
                    this._configService.selectedcompareacrossOption = this.customData.selectedcompareacrossOption || "";
                }
                const existingConfig = this._configService.outputSnapshotData;
                const hasMasterData = existingConfig && (Array.isArray(existingConfig.sig_testing_vs) || Array.isArray(existingConfig.comparison_point));

                if (!hasMasterData) {
                    this._configService.outputSnapshotData = { audienceCohortType: 'single' };
                }
                if (this._configService.baseSelected === undefined) {
                    this._configService.baseSelected = "Total Base";
                }
                (this._configService as any).isAskme = true;
                this._configService.IndexSelected = false;
            }

            // Ensure customizationProperties exists and has proper data label settings
            let needsUpdate = false;
            let finalProps: any;

            if (!this.customData.customizationProperties || this.customData.customizationProperties === '{}') {
                finalProps = {
                    showDataLabel: true,
                    dataLabelSize: '0.7em',
                    dataLabelColor: 'default',
                    datalabelStyle: 'default',
                    dataLabelPosition: 'center',
                    darkTheme: false,
                    showLegend: true,
                    legendPosition: 'bottom',
                    decimalRoundOff: 1
                };
                needsUpdate = true;
            } else {
                // Parse existing properties and ensure showDataLabel is true
                try {
                    // Handle both string and object type
                    finalProps = typeof this.customData.customizationProperties === 'string'
                        ? JSON.parse(this.customData.customizationProperties)
                        : this.customData.customizationProperties;
                    if (finalProps.showDataLabel === undefined || finalProps.showDataLabel === false) {
                        finalProps.showDataLabel = true;
                        needsUpdate = true;
                    }

                    // Ensure all required label properties exist
                    if (!finalProps.dataLabelSize) { finalProps.dataLabelSize = '0.7em'; needsUpdate = true; }
                    if (!finalProps.dataLabelColor) { finalProps.dataLabelColor = 'default'; needsUpdate = true; }
                    if (!finalProps.datalabelStyle) { finalProps.datalabelStyle = 'default'; needsUpdate = true; }
                    if (!finalProps.dataLabelPosition) { finalProps.dataLabelPosition = 'center'; needsUpdate = true; }
                    if (!finalProps.borderColor) { finalProps.borderColor = '#D3D3D3'; needsUpdate = true; }
                    if (!finalProps.borderStyle) { finalProps.borderStyle = '2'; needsUpdate = true; }

                } catch (e) {
                    console.error('[OUTPUT POPUP] ❌ Error parsing customizationProperties:', e);
                    finalProps = {
                        showDataLabel: true,
                        dataLabelSize: '0.7em',
                        dataLabelColor: 'default',
                        datalabelStyle: 'default',
                        dataLabelPosition: 'center',
                        borderColor: '#D3D3D3',
                        borderStyle: '2'
                    };
                    needsUpdate = true;
                }
            }

            if (needsUpdate) {
                // Create a new object reference to ensure Angular detects the change
                this.customData = {
                    ...this.customData,
                    customizationProperties: JSON.stringify(finalProps)
                };
            }
            if (!this.trendLineView) {
                this.trendLineView = finalProps?.trendlineOutputView;
                
                if (!this.trendLineView && this.customData?.customization_Properties_trendline) {
                    try {
                        const trendProps = typeof this.customData.customization_Properties_trendline === 'string'
                            ? JSON.parse(this.customData.customization_Properties_trendline)
                            : this.customData.customization_Properties_trendline;
                        this.trendLineView = trendProps?.trendlineOutputView;
                    } catch (e) {
                        console.error('[OUTPUT POPUP] Error parsing customization_Properties_trendline:', e);
                    }
                }
            }

            // BACKUP ORIGINAL DATA: Capture the original snapshot before any trend transformations, WITH validated properties
            this.originalSnapshotData = JSON.parse(JSON.stringify(this.customData));

            // [TRENDLINE ORCHESTRATION]
            let primaryModel = this.customData?.response_payload;
            if (typeof primaryModel === 'string') { try { primaryModel = JSON.parse(primaryModel); } catch(e){} }
            primaryModel = primaryModel?.dataModel;

            let trendModel = this.customData?.response_payload_trendline;
            if (typeof trendModel === 'string') { try { trendModel = JSON.parse(trendModel); } catch(e){} }
            trendModel = trendModel?.dataModel;
            const resolvedCompareAcross =
                this.customData?.selectedcompareacrossOption ||
                this.customData?.snapshot_type ||
                primaryModel?.Snapshot_Type ||
                primaryModel?.snapshot_type ||
                primaryModel?.compareAcross ||
                trendModel?.Snapshot_Type ||
                trendModel?.snapshot_type ||
                trendModel?.compareAcross;
            if (resolvedCompareAcross) {
                this._configService.selectedcompareacrossOption = resolvedCompareAcross;
                this._configService.selectedSnapshotType = resolvedCompareAcross;
            }

            let trendResponse = this.customData?.trendline_response;
            if (typeof trendResponse === 'string') {
                try {
                    trendResponse = JSON.parse(trendResponse);
                } catch (e) {}
            }
            const isTrendFlagDetected = primaryModel?.isTrend || trendModel?.isTrend;
            const hasTrendData = !!trendResponse?.Data;
            this.isTrendAvailable = isTrendFlagDetected || hasTrendData;
            this.isTrendAvailableChange.emit(this.isTrendAvailable);

            // [FUNNEL DIFFERENTIATION]
            const itemsSet = new Set<string>();
            if (this.customData?.metric?.[0]?.metric_value) {
                this.customData.metric[0].metric_value.forEach((mv: any) => {
                    if (mv.data && Array.isArray(mv.data)) {
                        mv.data.forEach((d: any) => {
                            if (d.colChild) {
                                const item = d.colChild.includes('|') ? d.colChild.split('|').pop() : d.colChild;
                                if (item) itemsSet.add(item.trim());
                            }
                        });
                    }
                });
            }
            this.funnelBrands = Array.from(itemsSet);
            const snapshotType = this._configService.selectedcompareacrossOption?.replace(/\s+/g, '').toLowerCase();
            const widgetName = (this.customData?.widgetchart_name || '').toUpperCase();
            const isFunnel = widgetName.includes('FUNNEL');
            const isMultiBrandOrMarket = snapshotType === 'multiplebrands' || snapshotType === 'multiplemarkets' || snapshotType === 'multipleaudiences';

            if (isFunnel && isMultiBrandOrMarket && this.funnelBrands.length > 1) {
                this.isBrandFunnelDropdown = true;
                this.selectedFunnelBrand = this.selectedFunnelBrand || this.funnelBrands[0];
                this.filterFunnelData();
            } else {
                if (isFunnel) {
                    console.log('[OUTPUT POPUP] ℹ️ Funnel dropdown suppressed:', {
                        isMultiBrandOrMarket,
                        itemCount: this.funnelBrands.length,
                        snapshotType: snapshotType
                    });
                }
                this.isBrandFunnelDropdown = false;
            }

            if (hasTrendData) {
                try {
                    const rawData = trendResponse.Data;
                    const trendDataArray = typeof rawData === 'string' ? JSON.parse(rawData) : rawData;
                    this.trendlineSnapshotData = this.buildAskMeTrendlineData(trendDataArray);
                    this.initializeTrendDropdownState(true);

                    if (this.isTrendActive || isTrendFlagDetected) {
                        this.customData = JSON.parse(JSON.stringify(this.trendlineSnapshotData));
                        this.filteredFunnelData = JSON.parse(JSON.stringify(this.trendlineSnapshotData));
                        this.visualization = 'Line Chart';
                        this.charttype = 'Line Chart';
                        this.initializeTrendDropdownState(true);
                        this.isBrandFunnelDropdown = false;
                    } else {
                        this.customData = JSON.parse(JSON.stringify(this.originalSnapshotData));
                        this.filteredFunnelData = JSON.parse(JSON.stringify(this.originalSnapshotData));

                        const widgetName = (this.customData?.widgetchart_name || '').toUpperCase();
                        const isFunnel = widgetName.includes('FUNNEL');
                        const snapshotType = this._configService.selectedcompareacrossOption?.replace(/\s+/g, '').toLowerCase();
                        const isMultiBrandOrMarket = snapshotType === 'multiplebrands' || snapshotType === 'multiplemarkets' || snapshotType === 'multipleaudiences';

                        if (isFunnel && isMultiBrandOrMarket && this.funnelBrands.length > 1) {
                            this.isBrandFunnelDropdown = true;
                            this.filterFunnelData();
                        } else {
                            this.isBrandFunnelDropdown = false;
                        }
                    }
                } catch (e) {
                    console.error('[OUTPUT POPUP] Trend Error:', e);
                    this.filteredFunnelData = this.customData;
                }
            } else {
                this.filteredFunnelData = this.customData;
            }

            this._cdref.markForCheck();

            if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
                this.viewList = this.viewListBrands;
                this.viewselected = this.viewList[0].option;
            }
            if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
                this.viewList = this.viewListMarkets;
                this.viewselected = this.viewList[0].option;
            }
            if (this.multiFunnelPopup) {
                this.customData.metric[0].metric_value[0].data.forEach((d: any) => {
                    // this.brandList.push(d.colChild);
                    this.gridData.push({
                        header: d.colChild,
                        data: this.customData
                    })
                })
            }
            if (!hasTrendData && this.metricList.length > 0) {
                if (!this.isTrendActive) {
                    this.metricSelected = this.metricList[0];
                }
                this.metricList = this.metricList.map((m: any, index: any) => {
                    return {
                        option: m,
                        selected: !this.isTrendActive ? index === 0 : false
                    }
                })

            }
            if (!hasTrendData && this.brandList.length > 0) {
                if (!this.isTrendActive) {
                    this.brandSelected = "";
                }
                this.brandList = this.brandList.map((m: any, index: any) => {
                    return {
                        option: m,
                        selected: index === 0
                    }
                })

            }
            if (!hasTrendData) {
                this.BMList = this.metricList;
            }
            this.initializeExtraSelections();
        }
        else {
            if (
                this.data[0].metricSelected.metrics.length > 10 &&
                this.visualization === 'Line Chart'
            ) {
                this.Top10Container = true;
            }
            if (this.visualization == 'Funnel Chart') {
                this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
            }
            if (this.Top10Container == true) {
                this.Top10Toggle = true;
            }
        }

    }


    // Brand Funnel Filtering Logic
    filterFunnelData() {
        if (!this.customData || !this.selectedFunnelBrand) return;

        // Deep clone to avoid mutating original source
        const filtered = _.cloneDeep(this.customData);

        if (filtered.metric?.[0]?.metric_value) {
            const seenRows = new Set<string>();
            const uniqueMetrics = filtered.metric[0].metric_value.filter((mv: any) => {
                // Robust label extraction: check top level then first data item
                let rawLabel = mv.rowChild || (mv.data?.[0]?.rowChild) || '';

                // [DE-DUP FIX] Normalize label by stripping market/parent prefix (e.g. "Market | Step" -> "Step")
                const label = rawLabel.includes('|') ? rawLabel.split('|').pop() : rawLabel;
                const trimmedLabel = label ? label.trim() : null;

                if (trimmedLabel && seenRows.has(trimmedLabel)) {
                    return false;
                }
                if (trimmedLabel) {
                    seenRows.add(trimmedLabel);
                }
                return true;
            });

            filtered.metric[0].metric_value = uniqueMetrics;
            filtered.metric[0].metric_value.forEach((mv: any) => {
                if (mv.data && Array.isArray(mv.data)) {
                    // STRICT DE-DUPLICATION: Keep exactly ONE record for the selected brand per funnel step
                    // This prevents duplicate bars when the same brand exists in multiple markets/contexts
                    const brandRecords = mv.data.filter((d: any) => {
                        const brand = d.colChild?.includes('|') ? d.colChild.split('|').pop() : d.colChild;
                        return brand === this.selectedFunnelBrand;
                    });

                    // Take only the very first matching record for this brand
                    mv.data = brandRecords.length > 0 ? [brandRecords[0]] : [];
                }
            });
        }

        this.filteredFunnelData = filtered;
        this._cdref.markForCheck();
    }

    toggleFunnelBrandDropdown(event?: Event) {
        if (event) event.stopPropagation();
        this.isFunnelBrandDropdownOpen = !this.isFunnelBrandDropdownOpen;
    }

    selectFunnelBrand(brand: string, event?: Event) {
        if (event) event.stopPropagation();
        this.selectedFunnelBrand = brand;
        this.brandSelected = brand; // Synchronize for chart propagation
        this.isFunnelBrandDropdownOpen = false;

        // Force chart recreation to reset internal child states
        this.isChartVisible = false;
        this._cdref.detectChanges();

        this.filterFunnelData();

        this.isChartVisible = true;
        this._cdref.detectChanges();
    }
    viewselected: any = "All Brands for Selected Metric";
    viewSelected(item: any) {
        this.viewList.forEach((v: any) => {
            if (item.option == v.option) {
                v.selected = true;
                this.viewselected = v.option;
                if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
                    if (v.option == "All Brands for Selected Metric") {
                        this.brandSelected = "";
                        this.metricList.forEach((m: any, index: any) => {
                            m.selected = index === 0;
                        })
                        this.BMList = this.metricList;
                    }
                    else {
                        this.metricSelected = "";
                        this.brandList.forEach((m: any, index: any) => {
                            m.selected = index === 0;
                        })
                        this.brandSelected = this.brandList[0].option;
                        this.BMList = this.brandList;
                    }
                }
                if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
                    if (v.option == "All Markets for Selected Metric") {
                        this.brandSelected = "";
                        this.metricList.forEach((m: any, index: any) => {
                            m.selected = index === 0;
                        })
                        this.BMList = this.metricList;
                    }
                    else {
                        this.metricSelected = "";
                        this.brandList.forEach((m: any, index: any) => {
                            m.selected = index === 0;
                        })
                        this.brandSelected = this.brandList[0].option;
                        this.BMList = this.brandList;
                    }
                }
            }
            else {
                v.selected = false;
            }
            this._cdref.detectChanges();
        })
    }
    metricSelected: any = "";
    brandSelected: any = "";

    getLastLevel(value: string): string {
        if (!value) return '';
        if (value.includes('|')) {
            const parts = value.split('|');
            return parts[parts.length - 1];
        }
        return value;
    }

    brandMetricSelected(item: any, itemindex: any) {
        if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplebrands") {
            if (this.viewselected == "All Brands for Selected Metric") {
                this.metricList.forEach((v: any, index: any) => {
                    if (item.option == v.option && index == itemindex) {
                        v.selected = true;
                        this.metricSelected = v.option;
                    }
                    else {
                        v.selected = false;
                    }
                })
            }
            else {
                this.brandList.forEach((v: any, index: any) => {
                    if (item.option == v.option && index == itemindex) {
                        v.selected = true;
                        this.brandSelected = v.option;
                    }
                    else {
                        v.selected = false;
                    }
                })
            }
        }
        if (this._configService.selectedcompareacrossOption.replace(/\s+/g, '').toLowerCase() == "multiplemarkets") {
            if (this.viewselected == "All Markets for Selected Metric") {
                this.metricList.forEach((v: any, index: any) => {
                    if (item.option == v.option && index == itemindex) {
                        v.selected = true;
                        this.metricSelected = v.option;
                    }
                    else {
                        v.selected = false;
                    }
                })
            }
            else {
                this.brandList.forEach((v: any, index: any) => {
                    if (item.option == v.option && index == itemindex) {
                        v.selected = true;
                        this.brandSelected = v.option;
                    }
                    else {
                        v.selected = false;
                    }
                })
            }
        }
    }

    Top10selected() {
        this.Top10Toggle = true;
    }

    Allselected() {
        this.Top10Toggle = false;
    }

    DataLabelOnClick() {
        this.DataLabelOn = true;
    }

    DataLabelOffClick() {
        this.DataLabelOn = false;
    }

    collapseExandPopup() {
        this.dataEvent.emit(false);
        this.dataEventCustom.emit(false);

        this.dataEventTrend.emit(false);
    }


    prepareSampleSize() {
        this.opobject = {
            Column: [], Row: []
        }


        this.TrendToggleContainer = true;
        this.TrendToggleOn = true;

        if (!this._configService.trendOutputDbCallData || this._configService.trendOutputDbCallData.length === 0) {
            console.warn("[OUTPUT POPUP] Cannot prepare Sample Size: trendOutputDbCallData is empty.");
            return;
        }

        let data = [this.customData]

        const widgetDetailsInParticularPage = data.map((item: any) => item.widget_name);
        let uniqueObjects = [
            ...new Map(
                this._configService.trendOutputDbCallData
                    .filter((i: any) => widgetDetailsInParticularPage.indexOf(i.widgetName) > -1)
                    .map((item: any) => [item.widgetName, item])
            ).values()
        ];

        let pagedetails = _.cloneDeep(
            this._configService.trendOutputDbCallData.filter((i: any) => widgetDetailsInParticularPage.indexOf(i.widgetName) > -1)
        );

        uniqueObjects.forEach((i: any) => {
            let nestedArray1 = pagedetails
                .filter(
                    (p: any) =>
                        p.widgetName == i.widgetName
                )
                .map((p: any) => {
                    return {
                        CalculationType: p.CalculationType,
                        Child: p.rowChild,
                        Level1ColChild: p.Level1ColChild,
                        NestedArray: [],
                        customCalculationId: p.customCalculationId || null,
                        customGroupId: p.customGroupId || null,
                        isCustomCalculation: p.isCustomCalculation || false,
                        isCustomGroup: p.isCustomGroup || false,
                        isDerived: p.isDerived || false,
                        responsecode: p.rowResponseCode?.toString() ?? null,
                        variablecode: p.rowVariableCode,
                        unweightedBase:
                            this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                                ? p.totalUnweightedBase
                                : p.answerUnweightedBase,
                        weightedBase:
                            this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                                ? p.totalWeightedBase
                                : p.answerWeightedBase,
                        WeightedNumerator:
                            this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                                ? p.totalWeightedNumerator
                                : p.answerWeightedNumerator,
                        UnweightedNumerator:
                            this._configService.getDropdownValues()?.['baseType']?.toLowerCase() == 'total base'
                                ? p.CurrentNumeratorUnWeighted_Total
                                : p.CurrentNumeratorUnWeighted_Answer,
                        trend: true,
                        brand: p.colChild && p.colChild.includes("|") ? p.colChild.split("|").pop().trim() : p.colChild,
                        ChildName: p.rowChild.includes("|") ? p.rowChild.split("|").pop().trim() : p.rowChild
                    };
                });


            this.opobject.Row.push({
                Data: [{
                    CalculationType: i.CalculationType || "share",
                    Child: i.widgetName,
                    Level1ColChild: i.Level1ColChild,
                    NestedArray: nestedArray1,
                    customCalculationId: i.customCalculationId || null,
                    customGroupId: i.customGroupId || null,
                    isCustomCalculation: i.isCustomCalculation || false,
                    isCustomGroup: i.isCustomGroup || false,
                    isDerived: i.isDerived || false,
                    responsecode: "1",
                    variablecode: "MO_MOb_2b_DAYPART",
                    ChildName: i.Level1ColChild.includes("|") ? i.Level1ColChild.split("|").pop().trim() : i.Level1ColChild
                }
                ],
                Data1: [{ NestedArray: [] }],
                Parent: (i.colChild && i.colChild.includes("|")) ? i.colChild.split("|").pop().trim() : (i.brand || i.colChild),
                customCalculationId: i.customCalculationId || null,
                customGroupId: i.customGroupId || null,
                isCustomCalculation: i.isCustomCalculation || false,
                isCustomGroup: i.isCustomGroup || false
            })
        })

        let uniqueColObjects = Object.values(this._configService.trendOutputDbCallData.reduce((acc: any, obj: any) => {
            acc[obj.Level1ColChild] = obj;
            return acc;
        }, {}));

        uniqueColObjects.sort((a: any, b: any) => {
            const aCode = this.parseResponseCode(a.Level1ColResponseCode);
            const bCode = this.parseResponseCode(b.Level1ColResponseCode);

            // Compare year first, then number if years are equal
            if (!Number.isNaN(aCode.year) && !Number.isNaN(bCode.year)) {
                if (aCode.year !== bCode.year) {
                    return aCode.year - bCode.year;
                }
            }
            return aCode.num - bCode.num;
        });

        uniqueColObjects.sort((a: any, b: any) => {
            let firstData = a.Level1ColChild;
            let secondData = b.Level1ColChild;
            if (firstData.includes("|")) {
                firstData = firstData.split("|").pop()
                secondData = secondData.split("|").pop();

                if (firstData.includes("_")) {
                    firstData = firstData.split("_")[1];
                    secondData = secondData.split("_")[1];
                }

                firstData = parseInt(firstData);
                secondData = parseInt(secondData);
            } else {
                firstData = parseInt(firstData);
                secondData = parseInt(secondData);

            }
            return firstData - secondData;
        })
        uniqueColObjects.forEach((i: any) => {
            let col = {
                Data: [{
                    CalculationType: i.CalculationType,
                    Child: i.Level1ColChild,
                    NestedArray: [],
                    customCalculationId: null,
                    customGroupId: null,
                    isCustomCalculation: false,
                    isCustomGroup: false,
                    isDerived: false,
                    responsecode: i.Level1ColResponseCode,
                    variablecode: i.Level1NestColVariableCode,
                    ChildName: i.Level1ColChild.includes("|") ? i.Level1ColChild.split("|").pop().trim() : i.Level1ColChild
                }],
                Parent: "Month",
                customCalculationId: null,
                isCustomCalculation: false,
                isCustomGroup: false
            }
            if (!this.opobject.Column.includes(col)) {
                this.opobject.Column.push(col);
            }
        })


        //     Level1ColChild
        // : 
        // "Month|May_2023"
        // Level1ColResponseCode
        // : 
        // "5 2023"
        // Level1NestColVariableCode
        // : 
        // "Month_code"

        this.sampleSizeOutputData = JSON.parse(JSON.stringify(this._configService.trendOutputDbCallData));
        this.sampleSizeOutputData = this.sampleSizeOutputData.filter((m: any) => widgetDetailsInParticularPage.indexOf(m.widgetName) > -1)

        // Sanitize colChild and rowChild for shared-popup which hardcodes split('|')[1]
        this.sampleSizeOutputData.forEach((m: any) => {
            if (m.colChild && m.colChild.includes('|')) {
                const parts = m.colChild.split('|');
                if (parts.length > 2) {
                    m.colChild = parts[0] + '|' + parts.pop().trim();
                }
            }
            if (m.rowChild && m.rowChild.includes('|')) {
                const parts = m.rowChild.split('|');
                if (parts.length > 2) {
                    m.rowChild = parts[0] + '|' + parts.pop().trim();
                }
            }
        });

        this.OutputdataObject = this.opobject;
        this.isSampleSize = true;



        this.isTrendView = false;
        this.isSampleSize = true;

        this._cdref.markForCheck();
    }

    parseResponseCode(code: any) {
        const [num, year] = code.split(' ');
        return { num: parseInt(num, 10), year: parseInt(year, 10) };
    };

    // Deleted redundant fetchWeights as initializeExtraSelections handles master config

    initializeExtraSelections() {

        // Sync from global service to ensure local isolated service has master study configuration
        if (this._globalConfigService && this._configService) {
            if (this._globalConfigService.brandData && !this._configService.brandData) {
                this._configService.brandData = this._globalConfigService.brandData;
            }
            if (this._globalConfigService.weights && !this._configService.weights) {
                this._configService.weights = this._globalConfigService.weights;
            }
            if (this._globalConfigService.outputSnapshotData && !this._configService.outputSnapshotData) {
                this._configService.outputSnapshotData = this._globalConfigService.outputSnapshotData;
            }
        }

        // Detect Client/Study context for parallel fetches
        const client = (this.snapshotConfig?.client_name) || this._configService.clientName || '';
        const study = (this.snapshotConfig?.study) || this._configService.selectedStudy || '';

        // PRIORITY 1: Merge masterStudyConfig (passed from parent pre-fetch) if available
        const localMaster = this.masterStudyConfig || this._configService.outputSnapshotData;
        const hasMasterInScope = localMaster && (Array.isArray(localMaster.sig_testing_vs) || Array.isArray(localMaster.comparison_point));

        // PRIORITY 2: Use directly passed snapshot config from parent (most reliable)
        if (this.snapshotConfig && typeof this.snapshotConfig === 'object') {

            // Merge with master metadata (either from Input or Service cache)
            if (hasMasterInScope && !Array.isArray(this.snapshotConfig.sig_testing_vs)) {
                this.snapshotConfig = { ...localMaster, ...this.snapshotConfig };
            }

            this._configService.outputSnapshotData = this.snapshotConfig;
            if (this.snapshotConfig.brandMetadata) this._configService.brandData = this.snapshotConfig.brandMetadata;
            if (this.snapshotConfig.brand_metadata) this._configService.brandData = this.snapshotConfig.brand_metadata;
            if (this.snapshotConfig.weights) this._configService.weights = this.snapshotConfig.weights;

            // Initial population from snapshotConfig (sets current selection + master options if merged)
            this.populateAnalyticalControls(this.snapshotConfig);
        }

        const config = (this._configService.outputSnapshotData && Object.keys(this._configService.outputSnapshotData).length > 0)
            ? this._configService.outputSnapshotData
            : localMaster;

        // Ensure master lists are populated if they exist in cache 
        if (config && (Array.isArray(config.sig_testing_vs) || Array.isArray(config.comparison_point) || Array.isArray(config.significance_type))) {
            this.populateAnalyticalControls(config);
        } else {
            console.warn('[OUTPUT POPUP] ⚠️ Master metadata still missing from current context.');
        }
    }

    handleMetadataResponse(data: any) {
        if (!data) return;

        let parsedData: any = null;

        try {
            if (data.Data && data.Data !== '') {
                parsedData = (typeof data.Data === 'string') ? JSON.parse(data.Data) : data.Data;
            } else if (data.Config && data.Config !== '') {
                parsedData = (typeof data.Config === 'string') ? JSON.parse(data.Config) : data.Config;
            } else {
                parsedData = data;
            }
        } catch (e) {
            console.warn('[OUTPUT POPUP] Parse error, using raw Data property', e);
            parsedData = data.Data || data;
        }

        // Drill into configData if present (Matches Ref)
        if (parsedData && parsedData.configData) {
            parsedData = parsedData.configData;
        }

        this._configService.outputSnapshotData = parsedData;

        // Map specific properties (Matches Ref)
        if (parsedData.brandMetadata) this._configService.brandData = parsedData.brandMetadata;
        else if (parsedData.brand_metadata) this._configService.brandData = parsedData.brand_metadata;

        if (parsedData.weight) this._configService.weights = parsedData.weight;
        else if (parsedData.weights) this._configService.weights = parsedData.weights;

        this.populateAnalyticalControls(parsedData);
    }

    populateAnalyticalControls(config: any) {
        if (!config || typeof config !== 'object') return;

        // 1. Significance Types
        const sigTypeCandidate = config.significance_type || [];
        this.significanceTypes = (Array.isArray(sigTypeCandidate) ? sigTypeCandidate : []).map((type: any, index: number) => ({
            id: index + 1,
            selected: false,
            name: type.key,
            value: type.key
        }));

        // 2. Significance Values
        const currentSigSelection = config.significance || 'None';
        this.significanceVal = [{ key: 'None', value: true, isSelected: (currentSigSelection === 'None') }];
        if (currentSigSelection === 'None') this.displaySignificance = 'None';

        // Candidates: comparison_point (Priority) then sig_testing_vs
        let rawSignificance = Array.isArray(config.comparison_point) ? config.comparison_point : (Array.isArray(config.sig_testing_vs) ? config.sig_testing_vs : []);

        // Sorting: Move "Reference" to end (Matches Ref)
        const significance = [...rawSignificance];
        const refIndex = significance.findIndex((item: any) => item.key === 'Reference');
        if (refIndex !== -1) {
            const refItem = significance.splice(refIndex, 1)[0];
            significance.push(refItem);
        }

        significance.forEach((item: any) => {
            if (item && item.key && (item.value === true || item.isSelected)) {
                const isSelected = (item.key === currentSigSelection);
                this.significanceVal.push({ ...item, isSelected });
                if (isSelected) {
                    this.displaySignificance = item.key;
                }
            }
        });

        // 3. Index (Mirror Ref: significanceVal without None)
        this.index = _.cloneDeep(this.significanceVal).filter((i: any) => i.key !== 'None');

        // 4. Confidence Levels (Matches Ref)
        this.confidenceLevel = [];
        const rawCL = Array.isArray(config.confidence_level) ? config.confidence_level : [];
        const levels = rawCL.filter((item: any) => item.value === true).sort((a: any, b: any) => {
            const numA = parseFloat(a.key?.toString().replace('%', '') || '0');
            const numB = parseFloat(b.key?.toString().replace('%', '') || '0');
            return numA - numB;
        });

        if (levels.length > 0) {
            this.confidenceLevel = levels;
            const selectedCL = levels.find((l: any) => l.isSelected || l.key === config.confidence_level_value);
            if (selectedCL && selectedCL.key && selectedCL.key.toLowerCase() !== 'nan') {
                this.displayConfidenceLevel = selectedCL.key;
                levels.forEach((l: any) => l.isSelected = (l === selectedCL));
            } else {
                this.displayConfidenceLevel = levels[0].key;
                levels[0].isSelected = true;
            }
        } else if (config.confidence_level !== undefined) {
            // AgentPayload Fallback
            let curLevel = Number(config.confidence_level);
            const defaultLevels = [0.90, 0.95, 0.99];

            // Defensively handle invalid or NaN levels by defaulting to 90%
            if (isNaN(curLevel) || curLevel === 0) {
                curLevel = defaultLevels[0];
            }

            const levelsList = defaultLevels.includes(curLevel) ? defaultLevels : [curLevel, ...defaultLevels.filter((l: number) => l !== curLevel)];
            this.confidenceLevel = levelsList
                .filter(l => !isNaN(l))
                .map((l: number) => ({
                    key: `${Math.round(l * 100)}%`,
                    value: true,
                    isSelected: l === curLevel
                }));

            const found = this.confidenceLevel.find(c => c.isSelected);
            this.displayConfidenceLevel = found ? found.key : (this.confidenceLevel[0]?.key || '90%');
        }

        // 5. Weights - Dynamic Label Mapping ('Primary Weight', 'Secondary Weight', 'Unweighted')
        const weightCandidate = this._configService.weights || config.weight || config.weights;
        const preMappedWeights = Array.isArray(weightCandidate) ? weightCandidate.filter((w: any) => w.isSelected || w.is_selected) : [];

        this.weight = [];
        preMappedWeights.forEach((w: any, index: number) => {
            const label = index === 0 ? "Primary Weight" : (index === 1 ? "Secondary Weight" : (w.variable_label || w.key || `Weight ${index + 1}`));
            this.weight.push({
                ...w,
                key: label, // Display in UI
                label: label,
                value: w.variable_code || w.value || w.key // Internal value for SnapshotService (e.g., 'Weight 1')
            });
        });

        // Ensure 'Unweighted' is always present per reference dashboard behavior
        if (!this.weight.find(w => w.key === "Unweighted")) {
            this.weight.push({ key: "Unweighted", label: "Unweighted", value: "Unweighted" });
        }

        // Initialize weight selection using config.weight or default to Primary/Unweighted
        if (this.weight.length > 0) {
            const currentWeight = config.weight_value || config.weight || '';
            const found = this.weight.find(w => w.value === currentWeight);
            const initial = found || this.weight[0];

            this.weightSelectedValue = initial.key;
            this._configService.weightSelected = initial.value;
            this._configService.weightLabel = initial.key;
        }

        // 6. Brands for Reference (Matches Ref)
        let rawBrandData = this._configService.brandData || config.brandMetadata || config.brand_metadata;

        if (!rawBrandData && Array.isArray(config.primary_brands)) {
            rawBrandData = config.primary_brands.map((b: any) => {
                if (typeof b === 'string') return { MetricOption: b, is_snapshot: 1, isSelected: false, hasNextLevel: false, isExpanded: false };
                return { MetricOption: b.brand || b.name || b.key || String(b), is_snapshot: 1, isSelected: false, hasNextLevel: false, isExpanded: false };
            });
        }

        this.allbrands = _.cloneDeep(Array.isArray(rawBrandData) ? rawBrandData : [])
            .filter((item: any) => item.is_snapshot != 0)
            .map((item: any) => ({
                ...item,
                isSelected: false,
                hasNextLevel: false,
                isExpanded: false
            }));

        this.allbrands.unshift({ MetricOption: "None", isSelected: true, hasNextLevel: false, isExpanded: false });
        this.allSigBrands = _.cloneDeep(this.allbrands);

        // 7. Base and Base2 (Simplified for Total/Answer Base only)
        const isTotalBaseVal = (config.isTotalBase === true || config.base === 'Total Base');
        this.isAnswerBase = (config.is_answer_base !== false);
        this.baseselected = isTotalBaseVal ? 'Total Base' : 'Answer Base';
        this._configService.isTotalBase = isTotalBaseVal;

        this.base = [
            { key: 'Total Base', selected: isTotalBaseVal },
            { key: 'Answer Base', selected: !isTotalBaseVal }
        ];
        this.base2 = [
            { key: 'Total Base', selected: isTotalBaseVal }
        ];


        this.y1 = _.cloneDeep(this._configService.passdata || {});

        setTimeout(() => {
            try {
                this._cdref.markForCheck();
                this._cdref.detectChanges();
            } catch (e) { }
        }, 100);
    }

    select(block: string, event: Event) {
        event?.stopPropagation();
        if (block === 'sig') {
            this.isSigSelected = true;
            this.isIndexSelected = false;
            this.sigConBaseToggle = true;
            this._configService.IndexSelected = false;
            this.searchQuery = '';
            this.displayReference = 'None';
            this.referenceDropdownToggle = false;
        } else if (block === 'index') {
            this.isSigSelected = false;
            this.isIndexSelected = true;
            this.sigConBaseToggle = false;
            this._configService.IndexSelected = true;
            this.significanceDropdownToggle = false;
            this.ConfidenceLevelDropDownToggle = false;
        }
        this._cdref.detectChanges();
    }

    onSignificanceDropdown(event: Event) {
        this.significanceDropdownToggle = !this.significanceDropdownToggle;
        this.ConfidenceLevelDropDownToggle = false;
        this.BaseDropDownToggle = false;
        this.weightDropDownToggle = false;
        event?.stopImmediatePropagation();
    }

    closeSignificance() {
        this.significanceDropdownToggle = false;
    }

    significanceSelected1(item: any, event: any) {
        if (item.key === 'Reference') {
            this.displayBrand = !this.displayBrand;
            event?.stopPropagation();
            return;
        }
        this.displaySignificance = item.key;
        this._configService.updateSignificanceValue(item.key);
        this.significanceVal.forEach(v => v.isSelected = (v.key === item.key));
        this.significanceDropdownToggle = false;
        event?.stopPropagation();
        this._cdref.detectChanges();

        // Call snapshot-payload-service to re-render chart with new significance
        this.applySignificanceChange(item.key, '');
    }

    /**
     * Calls snapshotPayloadService API when significance/reference selection changes,
     * then re-renders the chart with the updated response data.
     * The API returns a flat array of chart records (same format as the initial snapshot response):
     * { response: { Data: "[{widgetName, rowChild, colChild, answerWeightedShare, ...}]" } }
     */
    private async applySignificanceChange(significanceKey: string, referenceKey: string) {
        // Try multiple sources for response_payload — customData first, then originalSnapshotData, then snapshotConfig
        const responsePayload = this.customData?.response_payload
            || this.originalSnapshotData?.response_payload
            || this.snapshotConfig?.response_payload;

        if (!responsePayload) {
            console.warn('[OUTPUT POPUP] No response_payload available for significance re-render. customData keys:', Object.keys(this.customData || {}));
            return;
        }

        // Resolve auth/context from chatbotexpand component
        const bearerToken = await this._chatbotexpandComponent.getBearerToken();
        const sessionId = this._chatbotexpandComponent.guidChatId || '';

        const snapshotCfg = this.snapshotConfig || {};
        const passdata = this._configService.passdata || {};

        const clientName = snapshotCfg.client_name || passdata.client_name || this._configService.clientName || '';
        const study = snapshotCfg.study || passdata.study || this._configService.selectedStudy || '';

        // Build significanceVsBrandReference (empty for simple options, populated for Reference+brand)
        const sigVsBrand = referenceKey
            ? [{ Parent: 'Brands', SortId: 120007, Data: [] }]
            : [];

        const confidenceLevel = this.displayConfidenceLevel || '95%';
        const base = this.baseselected || 'Total Base';

        let selectedWeight = 'Weight';
        if (this.weightSelectedValue === 'Primary Weight' || this.weight[0]?.key === this.weightSelectedValue) {
            selectedWeight = 'Weight';
        } else if (this.weightSelectedValue === 'Secondary Weight' || this.weight[1]?.key === this.weightSelectedValue) {
            selectedWeight = 'weightB';
        } else if (this.weightSelectedValue === 'Unweighted' || this.weight[2]?.key === this.weightSelectedValue) {
            selectedWeight = 'Unweighted';
        } else {
            selectedWeight = (this._configService as any).weightSelected || 'Weight';
        }

        const weightParam = (this.weight && this.weight.length > 0) ? this.weight[0].key : 'Weight 1';
        let apiPayload: any = {
            bearer_token: bearerToken,
            session_id: sessionId,
            client_name: clientName,
            study: study,
            payload: responsePayload,
            Significance: significanceKey,
            SignificanceVsReference: significanceKey.toLowerCase() === 'reference' ? (referenceKey || significanceKey) : '',
            significanceVsBrandReference: sigVsBrand,
            'Confidence Level': confidenceLevel,
            Base: base,
            Weight: selectedWeight || weightParam
        };

        this._loaderService.showLoader();
        this.isSignificanceLoading = true;
        this._cdref.detectChanges();

        this._sigSub?.unsubscribe();

        this._sigSub = this._chatbotService.snapshotPayloadService(apiPayload).subscribe({
            next: (res: any) => {
                this.isSignificanceLoading = false;

                try {
                    // Parse the flat record array from response.Data (JSON string)
                    const rawDataStr = res?.response?.Data;
                    if (!rawDataStr) {
                        console.warn('[OUTPUT POPUP] snapshotPayloadService: empty response.Data');
                        this._cdref.markForCheck();
                        return;
                    }

                    const flatRecords: any[] = typeof rawDataStr === 'string'
                        ? JSON.parse(rawDataStr)
                        : rawDataStr;

                    if (!Array.isArray(flatRecords) || flatRecords.length === 0) {
                        console.warn('[OUTPUT POPUP] snapshotPayloadService: no records in parsed Data');
                        this._cdref.markForCheck();
                        return;
                    }

                    // Identify which widget to show — match by current widget_name, else first unique widget
                    const currentWidgetName = this.customData?.widget_name;
                    const targetWidgetName = currentWidgetName
                        ? (flatRecords.find(r => r.widgetName === currentWidgetName)?.widgetName || flatRecords[0].widgetName)
                        : flatRecords[0].widgetName;

                    // Filter to records for this widget
                    const widgetRecords = flatRecords.filter(r => r.widgetName === targetWidgetName);

                    // Fallback base value (for rows where base might be null)
                    const fallbackBase = widgetRecords.find(r => r.answerUnweightedBase != null)?.answerUnweightedBase || 999;

                    // Transform flat records into metric_value array grouped by rowChild
                    // (same transformation as chatbotexpand.component.ts)
                    const uniqueRowChildren = [...new Map(widgetRecords.map(r => [r.rowChild, r])).values()];

                    // Build the refreshed widget object, preserving original chart metadata
                    const prev = this.originalSnapshotData || this.customData;
                    const originalMetricItems = (prev.metric?.[0]?.metric_value || []);
                    const metricValues = uniqueRowChildren.map(representative => {
                        const originalIndex = originalMetricItems.findIndex((m: any) => (m.option || m.rowChild || m.metricName) === representative.rowChild);
                        const originalInfo = originalIndex !== -1 ? originalMetricItems[originalIndex] : null;

                        if (!originalInfo) {
                            console.log('[FUNNEL-DEBUG] ⚠️ No match for representative:', representative.rowChild);
                        }

                        const rowData = widgetRecords
                            .filter(r => r.rowChild === representative.rowChild)
                            .map(row => {
                                const colParts = (row.colChild || '').split('|');
                                const specificCol = colParts.pop() || row.colChild;
                                const parentLabel = colParts.pop() || 'Market';
                                const resolvedColChild = `${parentLabel}|${specificCol}`;

                                return {
                                    data: row.answerWeightedShare,
                                    data2: row.answerWeightedShareIndex,
                                    lvl1Child: row.Level1ColChild,
                                    colChild: resolvedColChild,
                                    rowChild: row.rowChild,
                                    totalUnweightedBase: row.totalUnweightedBase,
                                    totalUnweightedShare: row.totalUnweightedShare,
                                    totalWeightedBase: row.totalWeightedBase,
                                    totalWeightedShare: row.totalWeightedShare,
                                    totalWeightedShareIndex: row.totalWeightedShareIndex,
                                    answerUnweightedBase: row.answerUnweightedBase,
                                    answerUnweightedShare: row.answerUnweightedShare,
                                    answerWeightedBase: row.answerWeightedBase,
                                    answerWeightedShare: row.answerWeightedShare,
                                    answerWeightedShareIndex: row.answerWeightedShareIndex,
                                    changeVsPY_Answer: row.changeVsPY_Answer,
                                    changeVsPY_Total: row.changeVsPY_Total,
                                    changeVsPY: row.changeVsPY_Answer,
                                    Level1ColResponseCode: row.Level1ColResponseCode,
                                    Level1NestColVariableCode: row.Level1NestColVariableCode,
                                    CalculationType: row.CalculationType || 'share',
                                    CalculationTypeIndex: row.CalculationTypeIndex || 'index',
                                    baseValueforLSorIs: row.answerUnweightedBase ?? fallbackBase,
                                    Significance_Value: row.Significance_Answer
                                };
                            });

                        return {
                            option: representative.rowChild,
                            selectorder: originalIndex !== -1 ? (originalIndex + 1) : 999,
                            typeofmetric: 'METRIC',
                            metric_group: '',
                            data: rowData
                        };
                    });

                    // Maintain original order to prevent funnel chart levels from jumping
                    metricValues.sort((a: any, b: any) => (a.selectorder || 0) - (b.selectorder || 0));

                    const refreshed = {
                        ...prev,
                        widget_name: targetWidgetName,
                        widgetchart_name: widgetRecords[0]?.widgetChartType || prev.widgetchart_name,
                        metric: [{
                            metric_option: 'Data',
                            metric_group: '',
                            metric_value: metricValues
                        }],
                        response_payload: responsePayload // Preserve for next significance change
                    };

                    this.isChartVisible = false;
                    this._cdref.detectChanges();

                    this.customData = JSON.parse(JSON.stringify(refreshed));
                    this.filteredFunnelData = JSON.parse(JSON.stringify(refreshed));
                    // Update originalSnapshotData so trend toggle uses the significance-aware base
                    this.originalSnapshotData = JSON.parse(JSON.stringify(refreshed));

                    if (this.isBrandFunnelDropdown) {
                        this.filterFunnelData();
                    }

                    this.isChartVisible = true;
                    this._loaderService.hideLoader();
                    this._cdref.detectChanges();

                } catch (e) {
                    console.error('[OUTPUT POPUP] Error processing snapshotPayloadService response:', e);
                }

                this.isSignificanceLoading = false;
                this._loaderService.hideLoader();
                this._cdref.markForCheck();
                this._cdref.detectChanges();
            },
            error: (err: any) => {
                console.error('[OUTPUT POPUP] snapshotPayloadService error:', err);
                this.isSignificanceLoading = false;
                this._loaderService.hideLoader();
                this._cdref.detectChanges();
            }
        });
    }

    onConfidenceLevelDropdown(event: Event) {
        this.ConfidenceLevelDropDownToggle = !this.ConfidenceLevelDropDownToggle;
        this.significanceDropdownToggle = false;
        this.BaseDropDownToggle = false;
        this.weightDropDownToggle = false;
        event?.stopImmediatePropagation();
    }

    confidenceLevelSelected(item: any, event: any) {
        this.displayConfidenceLevel = item.key;
        if (this.confidenceLevel) {
            this.confidenceLevel.forEach(c => c.isSelected = (c.key === item.key));
        }
        this._configService.updateConfedenceValue(item.key);
        this.ConfidenceLevelDropDownToggle = false;
        event?.stopPropagation();

        // Trigger graph update with the new confidence level using current significance selection
        const currentSig = this.significanceVal?.find(v => v.isSelected)?.key || this.displaySignificance;
        const currentRef = this.selectedReference?.MetricOption || '';
        this.applySignificanceChange(currentSig, currentRef);
    }

    onCLclick() {
        // Handle accessibility if needed
    }

    onBaseDropdown(event: Event) {
        this.BaseDropDownToggle = !this.BaseDropDownToggle;
        this.significanceDropdownToggle = false;
        this.ConfidenceLevelDropDownToggle = false;
        this.weightDropDownToggle = false;
        event?.stopImmediatePropagation();
    }

    closeBaseDropdown() {
        this.BaseDropDownToggle = false;
    }

    baseSelected(item: any, event: any) {
        this.baseselected = item.key;
        this._configService.isTotalBase = (item.key === 'Total Base');
        this.base.forEach(b => b.selected = (b.key === item.key));
        this.BaseDropDownToggle = false;
        event?.stopPropagation();

        // Trigger graph update with the new base using current significance selection
        const currentSig = this.significanceVal?.find(v => v.isSelected)?.key || this.displaySignificance;
        const currentRef = this.selectedReference?.MetricOption || '';
        this.applySignificanceChange(currentSig, currentRef);
    }

    base2Selected(item: any, event: any) {
        this.baseselected = item.key;
        this._configService.isTotalBase = (item.key === 'Total Base');
        this.base2.forEach(b => b.selected = (b.key === item.key));
        this.BaseDropDownToggle = false;
        event?.stopPropagation();

        // Trigger graph update with the new base using current significance selection
        const currentSig = this.significanceVal?.find(v => v.isSelected)?.key || this.displaySignificance;
        const currentRef = this.selectedReference?.MetricOption || '';
        this.applySignificanceChange(currentSig, currentRef);
    }

    onWeightDropdown(event: Event) {
        this.weightDropDownToggle = !this.weightDropDownToggle;
        this.significanceDropdownToggle = false;
        this.ConfidenceLevelDropDownToggle = false;
        this.BaseDropDownToggle = false;
        event?.stopImmediatePropagation();
    }

    closeWeightDropdown() {
        this.weightDropDownToggle = false;
    }

    weightSelected(item: any, event: any) {
        this.weightSelectedValue = item.key;
        this._configService.weightSelected = item.value || item.variable_label;
        this._configService.weightLabel = item.key;
        this.weightDropDownToggle = false;
        event?.stopPropagation();

        // Trigger graph update with the new weight using current significance selection
        const currentSig = this.significanceVal?.find(v => v.isSelected)?.key || this.displaySignificance;
        const currentRef = this.selectedReference?.MetricOption || '';
        this.applySignificanceChange(currentSig, currentRef);
    }

    onReferenceDropdown(event: Event) {
        this.referenceDropdownToggle = !this.referenceDropdownToggle;
        event?.stopImmediatePropagation();
    }

    closeReferenceDropdown() {
        this.referenceDropdownToggle = false;
    }

    referenceSelected(item: any, event: any) {
        if (event && event.stopPropagation) {
            event.stopPropagation();
        }
        this.displayReference = item.MetricOption;
        this.referenceDropdownToggle = false;
        this.allbrands.forEach(b => b.isSelected = (b === item));
        this._cdref.detectChanges();
    }

    selectAudienceLevel2(parent: any, child: any, event: Event) {
        this.displayReference = child.Level2_value;
        this.referenceDropdownToggle = false;
        event?.stopPropagation();
        this._cdref.detectChanges();
    }

    searchBoxClick(event: Event) {
        event?.stopPropagation();
    }

    getFilteredBrandList() {
        if (!this.brandSearchQuery) return this.brandList;
        return this.brandList.filter((b: any) => b.option.toLowerCase().includes(this.brandSearchQuery.toLowerCase()));
    }

    onBrandSelected(item: any) {
        this.brandSelectedValue = item.option;
        this.brandDropDownToggle = false;
        this._cdref.detectChanges();
    }

    onBrandDropdown() {
        this.brandDropDownToggle = !this.brandDropDownToggle;
        event?.stopPropagation();
    }

    closeBrandDropdown() {
        this.brandDropDownToggle = false;
    }

    getFilteredCustomBaseOptions() {
        // Mocking for now as complex logic exists in custom-outputview
        return [];
    }

    brandSig(item: any, event: Event) {
        event?.stopPropagation();
        this.selectedReference = item;
        this.displaySignificance = item.MetricOption;
        this.allSigBrands.forEach(b => b.isSelected = (b === item));
        this.displayBrand = false;
        this._cdref.detectChanges();

        // Call snapshot-payload-service with Reference significance and selected brand
        this.applySignificanceChange('Reference', item.MetricOption);
    }

    toggleSigAudienceLevel1Expansion(item: any, event: Event) {
        event?.stopPropagation();
        this.selectedSigAudienceLevel1 = (this.selectedSigAudienceLevel1 === item) ? null : item;
        item.isExpanded = !item.isExpanded;
        this._cdref.detectChanges();
    }

    selectSigAudienceLevel2(parent: any, child: any, event: Event) {
        event?.stopPropagation();
        this.selectedSigBrand = { MetricOption: child.Level2_value };
        this.displaySignificance = child.Level2_value;
        this.displayBrand = false;
        this._cdref.detectChanges();
    }

    toggleAudienceLevel1Expansion(item: any, event: Event) {
        event?.stopPropagation();
        this.selectedAudienceLevel1 = (this.selectedAudienceLevel1 === item) ? null : item;
        item.isExpanded = !item.isExpanded;
        this._cdref.detectChanges();
    }

    applyBaseSelection() { }
    cancelBaseSelection() { }

}




